(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dod-delivery-date"] && !Shopify.designMode) return;
  try {
    function updateDodDeliveryDates() {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const arrival = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
    arrival.setUTCDate(arrival.getUTCDate() + 5);
    const formatted = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' }).format(arrival);
    document.querySelectorAll('[data-dod-delivery-date]').forEach(element => {
      const message = element.dataset.message.replace('[date]', formatted);
      if (element.textContent !== message) element.textContent = message;
    });
  }
  const deliveryObserver = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-dod-delivery-date]') || node.querySelector('[data-dod-delivery-date]'))))) updateDodDeliveryDates();
  });
  deliveryObserver.observe(document.documentElement, { childList: true, subtree: true });
  updateDodDeliveryDates();
  document.addEventListener('DOMContentLoaded', updateDodDeliveryDates);
  document.addEventListener('shopify:section:load', updateDodDeliveryDates);
  window.addEventListener('pageshow', updateDodDeliveryDates);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateDodDeliveryDates();
  });
  } catch(e) { console.error(e); }
})();

})();
